export default {
  meta: {
    title: '踩点宝-首页',
    url: '/footprinting/home', //  埋点字段，上报归属的模块
    urlName: '踩点宝' //  埋点字段，上报归属的模块
    // eventId: 'dad03a81-38bf-49a1-b77f-02f1dc2cdeb9'
  }
};
